










import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Slider extends Vue {
  @Prop() private boundValue!: number;
  @Prop() private clickEvent!: any;
  @Prop() private orientation!: string;
  @Prop() private maxWidth!: number;
  @Prop({ default: '#293c50' }) private color!: string;
  @Prop() private size!: { height: string, weight: string };
  @Prop() private additionalStyle!: object;
  private mouseOver = true;
  private event: any = {};
  private eventHandler: any = (event: MouseEvent) => this.barClick(event);
  private get outerSize(): object {
    const outerSize = this.size ? this.size :
      this.orientation === 'horizontal' ? { height: '50px', width: '500px' } : { height: '500px', width: '50px' };
    return this.additionalStyle ? Object.assign(this.additionalStyle, outerSize) : outerSize;
  }
  private get innerStyle(): object {
    const style = { background: this.color };
    return Object.assign(this.orientation === 'horizontal' ? { height: 'calc(100% - 2px)', width: this.boundValue + '%' }
      : { width: 'calc(100% - 2px)', height: `calc(${100 - this.boundValue}% - 2px)` }, style);
  }
  private barClick(event: MouseEvent): void {
    const clickPos = this.orientation === 'horizontal' ? event.offsetX : event.offsetY;
    const ref: any = this.$refs.outerBar;
    const maxWidth = this.orientation === 'horizontal' ? ref.clientWidth : ref.clientHeight;
    if (this.clickEvent) { this.clickEvent.event(clickPos / maxWidth); }
  }
  private addBarListener() {
    addEventListener('mousemove', this.eventHandler);
  }
  private removeBarListener() {
    removeEventListener('mousemove', this.eventHandler);
  }
}
